"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMENT_LINK_PROTOCOLS = exports.COMMENT_ATTRS = exports.COMMENT_TAGS = void 0;
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ What a comment body may contain. One list, both sides.                    │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **THE EDITOR AND THE SANITISER MUST NOT HOLD SEPARATE COPIES OF THIS.** The server decides
 * what can be stored; the editor decides what can be produced. When those two lists are written
 * out twice, the failure is silent in the worst direction — a toolbar button that formats text on
 * screen and whose markup the save strips, so the writer sees it work and the reader never sees it
 * at all. R-16 names this as the constraint the editor has to be built against.
 *
 * ⚠️ **`h1` is deliberately absent.** A comment sits inside a page that already has a document
 * heading; a second one is an outline error rather than a style choice. `hr` is absent for the same
 * kind of reason — a rule across a comment is a separator inside a separator.
 *
 * ⚠️ **`img` is absent and is the one entry with a plan behind it.** Attachments get their own
 * named volume with ClamAV scanning on upload; until that exists there is nothing for a `src` to
 * point at, and allowing the tag early would mean allowing an attribute that can name any host on
 * the internet. See `decisions.md`.
 */
exports.COMMENT_TAGS = [
    /** ⚠️ A text node is a tag to DOMPurify, and leaving it out deletes every word. See the service. */
    '#text',
    'b',
    'strong',
    'i',
    'em',
    'u',
    's',
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'code',
    'h2',
    'h3',
    'blockquote',
    'pre',
    'a',
];
/**
 * ⚠️ **`href` is the only attribute a comment may carry**, and `rel`/`target` are here because the
 * sanitiser WRITES them rather than because a comment may ask for them — a link opened in this tab
 * hands the destination a `window.opener` handle on the app.
 */
exports.COMMENT_ATTRS = ['href', 'rel', 'target'];
/** The schemes an `href` may use. Anything else is script execution wearing a link's clothes. */
exports.COMMENT_LINK_PROTOCOLS = ['http', 'https', 'mailto'];
//# sourceMappingURL=comment-markup.js.map